import { classNames, localeMoment } from "../../helpers";
import SessionModel from "../../api/models/SessionModel";
import { CalendarIcon, ClockIcon } from "@heroicons/react/outline";
import { getSessionState } from "./helper";
import { useTranslation } from "react-i18next";
import ActiveSessionTimeStatus from "./ActiveSessionTimeStatus";
type CandidateSessionCardProps = {
  session: SessionModel;
  sessionNumber?: number;
  sessionRanking?: boolean;
  cancelSession: () => void;
};

export default function CandidateSessionCard({
  session,
  sessionNumber,
  sessionRanking,
  cancelSession,
}: CandidateSessionCardProps) {
  const { t } = useTranslation("", {
    keyPrefix: "page.candidate.dashboard.room",
  });

  return (
    <li
      className="d-flex  flex-col justify-center items-between"
      data-cy="activeSessionCard"
      data-cy-session-status={session.status}
      data-cy-session-id={session.id}
    >
      <div className="w-full flex justify-between items-center mb-2">
        <h5 className="text-gray-700 capitalize text-sm font-medium">
          {sessionRanking ? t("sessionOne") : t("sessionTwo")}
        </h5>
        {session.canBeCanceled ? (
          <button
            type="button"
            className="text-red-500 capitalize text-xs font-normal"
            onClick={() => cancelSession()}
          >
            {t("cancelSession")}
          </button>
        ) : (
          ""
        )}
      </div>
      <div
        className={classNames(
          "w-full bg-white shadow rounded-lg  px-4 md:px-6 py-[18px] flex md:justify-between md:items-center",
          session.isInProgress
            ? "flex-col md:flex-row"
            : "flex-col-reverse md:flex-row"
        )}
      >
        <div className="md:w-1/2 flex flex-col-reverse  justify-between md:flex-row gap-4">
          <div className="text-gray-600 text-sm font-medium">
            <div className="flex flex-nowrap rounded-full items-center gap-2">
              <CalendarIcon className="h-5" />
              <p>{localeMoment(session.date!).format("dddd DD/MM/YYYY")}</p>
            </div>
          </div>
          <div className="text-gray-600  text-sm font-medium">
            <div className="flex rounded-full items-center gap-2">
              <ClockIcon className="h-5" />
              <p>{localeMoment(session.start_time!).format("hh:mm A")}</p>
            </div>
          </div>
        </div>
        {(session.isDone || session.isAbsence || session.isCanceled) && (
          <div
            className="md:w-48 h-[42px] w-full flex  mb-[10px] md:mb-0 items-center md:justify-end"
            data-cy="showDetails"
          >
            {getSessionState(session.status!)}
          </div>
        )}

        {session.isInProgress && (
          <div
            className="md:w-48 w-full flex  items-center mt-6 md:mt-0"
            data-cy="showDetails"
          >
            <ActiveSessionTimeStatus
              className="w-full text-base font-medium"
              session={session}
            />
          </div>
        )}
        {(session.isComing || session.isScheduled) && (
          <div
            className="w-48 h-[42px] mb-[10px] md:mb-0 flex items-center"
            data-cy="showDetails"
          >
            <ActiveSessionTimeStatus
              className={
                "bg-white text-brandblue-500 p-0 justify-start text-sm font-medium"
              }
              session={session}
            />
          </div>
        )}
      </div>
    </li>
  );
}
